import { Component, OnInit } from '@angular/core';
import {UtilsService} from "../../shared/utils.service";

@Component({
    selector: 'app-privacy',
    templateUrl: './privacy.component.html',
    styleUrls: ['./privacy.component.scss'],
    standalone: false
})
export class PrivacyComponent implements OnInit {

  constructor(private utils:UtilsService) { }

  ngOnInit(): void {
    this.utils.setTitle('Privacy');
  }

}
